import React, { type FC } from 'react'
import { CircularProgress, type CircularProgressProps } from '@mui/material'

import { BaseLoader, type BaseLoaderProps } from './Wrapper'

export const CircularLoader: FC<Pick<CircularProgressProps, 'size'> & BaseLoaderProps> = ({ size, ...props }) => (
    <BaseLoader {...props}>
        <CircularProgress size={size} />
    </BaseLoader>
)
